<template>
  <table class="summary-table">
    <thead>
      <tr>
        <td colspan="4" class="innerCaption">{{ $t('orderReport.summaryTitle') }}</td>
      </tr>
      <tr>
        <template v-for="mealEvent in mealEventsWithExras">
          <th :key="mealEvent.name">{{ $t(`orderReport.${mealEvent.name.toLowerCase()}`) }}</th>
        </template>
      </tr>
    </thead>
    <tbody>
      <tr class="totals">
        <template v-for="mealEvent in mealEventsWithExras">
          <td :key="mealEvent.name">{{ mealEvent.total }}</td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { EXTRAS_ID } from '@/constants';

export default {
  computed: {
    ...mapGetters('orders', { orders: 'getWeekOrders' }),
    ...mapState('events', { mealEvents: (state) => state.mealEvents }),
    mealEventsWithExras() {
      const mealEventsWithExras = [];
      this.mealEvents.forEach((mealEvent) => {
        const meal = {
          name: mealEvent.name.toLowerCase(),
          total: this.getTotalByEventWithoutExtras(mealEvent),
        };
        const mealExtras = {
          name: `${mealEvent.name.toLowerCase()}_extras`,
          total: this.getTotalByEventExtras(mealEvent),
        };
        mealEventsWithExras.push(meal);
        if (mealExtras.total) {
          mealEventsWithExras.push(mealExtras);
        }
      });
      return mealEventsWithExras;
    },
  },
  methods: {
    getTotalByEventWithoutExtras(mealEvent) {
      let result = 0;
      if (Object.keys(this.orders).length === 0) {
        result = 0;
      } else {
        result = this.orders.filter(
          (item) => item.menuInfo.event === mealEvent.id && item.mealInfo.dietInfo.id !== EXTRAS_ID
        ).length;
      }
      return result;
    },
    getTotalByEventExtras(mealEvent) {
      let result = 0;
      if (Object.keys(this.orders).length === 0) {
        result = 0;
      } else {
        result = this.orders.filter(
          (item) => item.menuInfo.event === mealEvent.id && item.mealInfo.dietInfo.id === EXTRAS_ID
        ).length;
      }
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';
.summary-table {
  width: 100%;
  th:not(:empty),
  td {
    border: 1px solid $order-report-table-color;
    padding: 1em;
  }
  .totals {
    font-weight: 500;
  }
}
.innerCaption {
  text-align: center;
  background-color: $order-report-table-color;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/table/SummaryTable.vue